import { render, staticRenderFns } from "./Licences.vue?vue&type=template&id=fb826206&scoped=true"
import script from "./Licences.vue?vue&type=script&lang=js"
export * from "./Licences.vue?vue&type=script&lang=js"
import style0 from "./Licences.vue?vue&type=style&index=0&id=fb826206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb826206",
  null
  
)

export default component.exports